import { Directive } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { helperFunctions } from 'src/app/utils/cf-checker-util';

export function ValidateSessoCF(control: AbstractControl): {[key: string]: any} | null  {
    
    if (control.parent && control.parent.get('cognomeDenominazione').value && control.parent.get('nome').value && control.parent.get('sesso').value && control.parent.get('codiceFiscale').value) {
        const cognome = control.parent.get('cognomeDenominazione').value;
        const nome = control.parent.get('nome').value;
        const sesso = control.parent.get('sesso').value;
        const CF = control.parent.get('codiceFiscale').value;
    
        const cfCheckerResult = helperFunctions.checkCodiceFiscale(cognome, nome, null, sesso, null, CF, false);
        return (cfCheckerResult === true) ? null : (cfCheckerResult.includes("Il giorno/sesso non corrisponde al CF !!"))? { sessocfnotvalid: true } : null;
    }
    
    return null; // return null if validation is passed.
}

@Directive({
  selector: '[appSessoCFValidatorDirective]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: AppSessoCFValidatorDirective,
    multi: true
  }]
})
export class AppSessoCFValidatorDirective implements Validator {
  validate(control: AbstractControl) : {[key: string]: any} | null {
    return ValidateSessoCF(control);
  }
}